import Button from '@atlaskit/button'
import Heading from '@atlaskit/heading'
import * as React from 'react'
import useWebSocket, { ReadyState } from 'react-use-websocket'
import { modalCss } from './styles'

export function OtpCode({ jwt, authWindow, updateIsSubscribedForOTP }) {
  const [hasWsError, setHasWsError] = React.useState(false)
  const { sendMessage, lastJsonMessage, readyState } = useWebSocket(
    new URL('/ws', `wss://${window.location.host}`).toString(),
    {
      shouldReconnect: (e) => true,
      reconnectInterval: 500,
      reconnectAttempts: 10,
      onReconnectStop(n) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to connect to the server. Attempts: ${n}`)
        setHasWsError(true)
      },
    },
  )

  React.useEffect(() => {
    async function receiveMessage(event) {
      if (event?.data !== 'get_panel_otp') {
        // eslint-disable-next-line no-console
        console.warn('Unknown event', event.data)

        return
      }

      if (!lastJsonMessage?.panelOTP) {
        await new Promise((resolve) => setTimeout(resolve, 1000))
      }

      authWindow &&
        authWindow.postMessage(
          {
            otp: lastJsonMessage?.panelOTP,
            system: lastJsonMessage?.system,
          },
          event.origin,
        )
    }

    window.addEventListener('message', (event) => receiveMessage(event))
  }, [authWindow, jwt, lastJsonMessage?.panelOTP, lastJsonMessage?.system])

  React.useEffect(() => {
    if (readyState === ReadyState.OPEN && jwt) {
      sendMessage(jwt)
    }
  }, [jwt, readyState, sendMessage])

  React.useEffect(() => {
    if (lastJsonMessage?.status === 'subscribed') {
      updateIsSubscribedForOTP(true)
    }
    if (lastJsonMessage?.status === 'done') {
      window.AP.dialog.close()
    }
  }, [lastJsonMessage])

  if (hasWsError) {
    return <Modal heading='Something went wrong'>Please close this dialog and try again</Modal>
  }

  if (lastJsonMessage?.panelOTP) {
    return (
      <Modal heading='Verify'>
        <p>If requested, please enter this code:</p>
        <h3>{lastJsonMessage?.panelOTP}</h3>
      </Modal>
    )
  }

  return <Modal heading='Loading...' />
}

function Modal({ heading, children }) {
  return (
    <section css={modalCss.wrapper}>
      <div css={modalCss.heading}>
        <Heading as='h1' level='h600'>
          {heading}
        </Heading>
      </div>
      <div css={modalCss.body}>{children}</div>
      <div css={modalCss.footer}>
        <Button
          onClick={() => {
            window.AP.dialog.close()
          }}
        >
          Cancel
        </Button>
      </div>
    </section>
  )
}
